import { Button, Flex, Text } from "@chakra-ui/react";
import { useState } from "react";
import { useEffect } from "react";
import Chart from "react-apexcharts";
import { Link } from "react-router-dom";
import Header from "../../../../../../components/Header";
import { baseURL } from "../../../../../../services/api";
import { useMarkup } from "../../../contexts/MarkupProvider";
import { Layout } from "../../Layout";
import { Title } from "../../Title";

export function MarkupGrafico() {
  const [data, setData] = useState({});

  async function getData() {
    const response = await baseURL.get("/pedido/lista-pedidos-simulacao-mes");

    setData(response.data);
  }

  const dataFormatted = Object.entries(data).map(([key, value]) => {
    return {
      name: key,
      data: value,
    };
  });

  useEffect(() => {
    getData();
  }, []);

  const options = {
    chart: {
      id: "basic-bar",

      toolbar: {
        show: true,
      },

      zoom: {
        enabled: true,
      },
    },
    xaxis: {
      categories: dataFormatted.map((item) => item.name),
    },
  };

  const series = [
    {
      name: "Pedidos",
      data: dataFormatted.map((item) => item.data),
    },
  ];

  return (
    <>
      <Layout>
        <Title>Gráfico Innovation Brindes</Title>
        <Flex display={"flex"} w="100%" flexDirection="column" alignItems="center" justifyContent="center">
          <Text fontSize="2xl" fontWeight="bold" mb="4" color="gray.500" letterSpacing="wide" textTransform="uppercase">
            Pedidos por mês {new Date().getFullYear()}
          </Text>
          <Chart options={options} series={series} type="bar" width="1500" height="400" />
        </Flex>

        <Button as={Link} to="/markup" colorScheme="blue" mt="4">
          Voltar
        </Button>
      </Layout>
    </>
  );
}
